import { ReactNode } from 'react';
import getAmoutValue from 'ui/structure/AmountValue/AmountValue';
import { ITransactionField } from 'ui/structure/TransactionCard';
import { objectMap } from 'utils/helpers';
import { ghsFormatter, formatTwoDigitDate, amountFormatter } from 'utils/formatters';
// import getCurrencyValue from 'ui/structure/CurrencyValue/CurrencyValue';

export const transactionDataConfig = {
  transactionId: 'Request ID:',
  transferType: 'Transfer Type:',
  sourceAccount: 'Source Account:',
  destinationAccountNo: 'Beneficiary:',
  genericTransType: 'Transfer Type:',
  destinationCountry: 'Beneficiary Country:',
  swiftCode: 'Swift Code:',
  transactionNarration: 'Narration:',
  workFlowStatus: 'Transaction Status:',
  createDate: 'Transaction Date:',
  transactionAmount: 'Amount:',
};

export const transactionValuesMapper = (value: string | number, key: string) => {
  switch (key) {
    case 'totalAmount':
    case 'transactionAmount':
      return getAmoutValue(String(value));
    case 'charge':
      return getAmoutValue(String(value));
    case 'createDate':
      return formatTwoDigitDate(value);
    case 'transactionCharge':
      return ghsFormatter.format(Number(value));
    default:
      return value;
  }
};

export const getTransactionsArray = (
  data: Record<string, string | number>,
  config: Record<string, string> = transactionDataConfig,
  mapper: (value: string | number, key: string) => ReactNode = transactionValuesMapper,
  sortArray?: string[],
  defaultCurrency = 'GHS',
): ITransactionField[] => {
  const mappedData = objectMap<ReactNode, string | number>(data, mapper, config);
  const transactionsArray: ITransactionField[] = [];
  const loopWithKeys = sortArray || Object.keys(mappedData);
  loopWithKeys.forEach((key) => {
    const value = mappedData[key];
    if (typeof value === 'undefined') return;
    if (key === 'Amount:') {
      const currencyCode = data.currencyCode ? data.currencyCode : defaultCurrency;
      transactionsArray.push({
        label: key,
        value: amountFormatter(String(currencyCode), false)(String(data.transactionAmount)),
      });
    } else {
      transactionsArray.push({ label: key, value });
    }
  });

  return transactionsArray;
};
